import initLighthouseFilter from '@PROJECT_ROOT/assets/desktop/js/lighthouse/searchLighthouseFilter';

$(() => {
    initLighthouseFilter({
        searchAjaxUrl: $('#lighthouseSearchAjaxUrl').data('url'),
    });
});
